import {useEffect, useState, useRef} from 'react';

const useScrollDirection = (threshold = 100) => {
    const [scrollDirection, setScrollDirection] = useState('up');
    const prevScrollY = useRef(0);
    const accumulatedScroll = useRef(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const scrollDiff = currentScrollY - prevScrollY.current;

            if (scrollDiff > 0) {
                accumulatedScroll.current += scrollDiff;
                
                if (accumulatedScroll.current >= threshold) {
                    setScrollDirection('down');
                    accumulatedScroll.current = 0;
                }
            } else if (scrollDiff < 0) {
                accumulatedScroll.current += scrollDiff;
                
                if (accumulatedScroll.current <= -threshold) {
                    setScrollDirection('up');
                    accumulatedScroll.current = 0;
                }
            }

            prevScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [threshold]);

    return scrollDirection;
};

export default useScrollDirection;